<template>
  <!--投诉新闻列表-->
  <div class="wrapper">
    <Header @callFather="getNewsClass"></Header>
    <div v-if="dingbu1.logo">
      <a class="guanggao" :href="dingbu1.dirlink" v-if="dingbu1.type&&dingbu1.type===1">
        <object data type>
          <embed style="width:1200px;height:100px;" :src="dingbu1.logo" type>
        </object>
      </a>
      <a class="guanggao" :href="dingbu1.dirlink" v-else>
        <img class="guanggao-img" :src="dingbu1.logo" alt>
      </a>
    </div>
    <div class="content-wrap">
      <div class="content-left">
        <div class="seat">
          <span>当前位置：</span>
          <router-link to="/">首页></router-link>
          {{newsListData.cate}}
        </div>
        <div class="title">
          <img style="width:380px;height:45px;" src="../assets/image/椭圆.png" alt>
          <div class="tousu" v-text="title"></div>
        </div>
        <!--新闻列表-->
        <NewsList
          v-for="(item,index) in listData"
          :key="index"
          :listData="item"
          :from="'complainInfo'"
          :articleId="item.id"
          :cate="title"
          :img="item.logo"
        ></NewsList>

        <div class="content-foot">
          <span class="article-number" v-text="'共'+newsListData.count+'篇文章'"></span>
          <span class="page-number">
            <span v-text="'第'+newsListData.page+'页'"></span> /
            <span v-text="'共'+newsListData.totalPage+'页'"></span>
            <span class="page-ref">
              <button @click="homePage">首页</button>
              <button @click="upPage">上一页</button>
              <button @click="downPage">下一页</button>
              <button @click="lastPage">尾页</button>
            </span>
          </span>
        </div>
      </div>

      <div class="content-right">
        <div>
          <CommentRank
            v-if="commentRank"
            v-show="id!=3"
            :more="false"
            :title="'评论榜'"
            :list="commentRank.data"
          ></CommentRank>

          <ranking
            v-if="newsModule[1]&&newsModule[1].type!==3"
            :more="false"
            :title="newsModule[1].title"
            :list="newsModule[1].data"
          ></ranking>
        </div>
        <div>
          <ranking
            v-if="newsModule[0]"
            :more="false"
            :title="newsModule[0].title"
            :list="newsModule[0].data"
          ></ranking>
        </div>

        <!--右侧广告位-->
        <a class="guanggao2" :href="art2.dirlink" v-if="art2.type&&art2.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art2.logo" type>
          </object>
        </a>

        <a class="guanggao2" :href="art2.dirlink" v-else>
          <img :src="art2.logo" alt style="width:380px;height:100px;">
        </a>

        <a class="guanggao3" :href="art3.dirlink" v-if="art3.type&&art3.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art3.logo" type>
          </object>
        </a>

        <a class="guanggao2" :href="art3.dirlink" v-else>
          <img style="width:380px;height:100px;" :src="art3.logo" alt>
        </a>
      </div>
    </div>

    <HomeFoot></HomeFoot>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HomeFoot from "@/components/HomeFoot.vue";
import NewsList from "@/components/NewsList.vue";
import Ranking from "@/components/Ranking.vue";
import CommentRank from "@/components/CommentRank.vue";

export default {
  name: "ComplainView",
  components: {
    Header,
    HomeFoot,
    NewsList,
    Ranking,
    CommentRank
  },
  data() {
    return {
      id: "", // 首页跳转时携带的分类id
      newsListData: "",
      listData: "",
      pageNumber: 1, //首页跳转默认1
      newsModule: [],
      commentRank: "", //评论榜排名
      title: "",
      dingbu1: "",
      art2: "",
      art3: ""
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.getNewsClass();
      this.getNewsModule();
    }
  },
  methods: {
    // 获取新闻列表数据
    getNewsClass() {
      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.title = this.$route.query.title;
      this.$post("https://315sd.0532.name/api/general/leader_board", {
        types: this.id,
        page: this.pageNumber
      })
        .then(res => {
          if (res.code === 0) {
            this.newsListData = res.data;
            this.listData = res.data.listData;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取右侧模块新闻
    getNewsModule() {
      this.$post("https://315sd.0532.name/api/general/lb_article", {
        types: this.id
      })
        .then(res => {
          if (res.code === 0) {
            this.newsModule = res.data;
            // this.ranking_one=this.newsModule[0]
            // console.log( '右侧数据',this.newsModule[0].data);
            for (let i = 0; i < this.newsModule.length; i++) {
              if (this.newsModule[i].type === 3) {
                this.commentRank = this.newsModule[i];
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //点击上下页执行的函数
    getNewsList(page) {
      this.$post("https://315sd.0532.name/api/general/leader_board", {
        types: this.id,
        page: page
      })
        .then(res => {
          if (res.code === 0) {
            this.newsListData = res.data;
            this.listData = res.data.listData;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    homePage() {
      this.getNewsList(1);
    },

    upPage() {
      if (this.newsListData.page === 1) {
        alert("已经是第一页了");
      } else {
        let pageNumber = (this.newsListData.page -= 1);
        this.getNewsList(pageNumber);
      }
    },

    // downPage() {
    //
    //   if (this.newsListData.page < this.newsListData.totalPage) {
    //     this.newsListData.page += 1
    //     this.getNewsList(this.newsListData.page)
    //   } else {
    //     this.$message('已经是最后一页.');
    //   }
    //
    //
    // },
    downPage() {
      let pageNumber = (this.newsListData.page += 1);
      if (pageNumber > this.newsListData.totalPage) {
        this.$message("已经是最后一页了.");
        this.newsListData.page -= 1;
      } else {
        this.getNewsList(pageNumber);
      }
    },
    // 跳转到尾页
    lastPage() {
      this.getNewsList(this.newsListData.totalPage);
    },
    getGuangGao() {
      this.$post("https://315sd.0532.name/index/index/complaint_list_ad", {
        type: 3
      })
        .then(res => {
          if (res.code === 0) {
            this.dingbu1 = res.data.ad1;
            this.art2 = res.data.ad2;
            this.art3 = res.data.ad3;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  mounted() {
    this.getNewsClass();
    this.getNewsModule();
    this.getGuangGao();
    // 每次刷新页面都跳转到页面顶部
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
};
</script>

<style scoped lang="less">
.content-wrap {
  display: flex;
  width: 1200px;
  margin: 32px auto;
  justify-content: space-between;
}

.guanggao {
  display: block;
  width: 1200px;
  margin: 20px auto;

  .guanggao-img {
    width: 1200px;
    height: 100px;
  }
}

.content-left {
  width: 780px;
  min-width: 780px;
  .seat {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-bottom: 40px;

    .seat > span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
}

.title {
  display: flex;
  height: 42px;
  border-bottom: 3px solid #d0021b;
  margin-bottom: 24px;
  position: relative;

  .tousu {
    position: absolute;
    width: 100px;
    height: 50px;
    line-height: 50px;
    font-size: 24px;
    font-family: FZLTTHJW--GB1-0;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    padding: 0 5px;
  }

  .search-wrap {
    width: 280px;
    height: 32px;
    border: 1px solid #dbdbdb;
    border-radius: 20px;
    margin: auto 0;

    .search {
      border: 0;
      outline: 0;
      width: 210px;
      height: 29px;
      margin-left: 12px;
      margin-top: 1px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      line-height: 32px;
    }
  }
}

.search-wrap > button {
  height: 25px;
  background: rgba(208, 2, 27, 1);
  padding: 0 10px;
  border-radius: 15px;
  color: #fdf8f8;
  line-height: 25px;
  font-size: 15px;
}

.content-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .article-number {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 19px;
  }

  .page-number {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 19px;

    .page-ref > button {
      margin: 10px;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      line-height: 19px;
      background-color: transparent;
    }
  }
}

.content-right {
  margin-top: 60px;
  margin-left: 40px;
}

.content-right > div {
  margin-bottom: 20px;
}
</style>
